// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Import JS
import menuOpen from "./menuOpen";
import infiniteScroll from "./infiniteScroll";
import { initProgressBar } from "./progressBar";
import { initTableOfContents } from "./tableOfContents";
import { initToolbarActions } from "./toolbarActions";

// Core layout functions
menuOpen();
infiniteScroll();

// Post-page functions (only run when elements exist)
initProgressBar();
initTableOfContents();
initToolbarActions();

// Copy link button
const copyBtn = document.getElementById('gh-copy-link');
if (copyBtn) {
    copyBtn.addEventListener('click', function () {
        const btn = this;
        const url = btn.dataset.url || window.location.href;

        function onSuccess() {
            btn.classList.add('is-copied');
            btn.setAttribute('aria-label', 'Copied!');
            setTimeout(() => {
                btn.classList.remove('is-copied');
                btn.setAttribute('aria-label', 'Copy link to clipboard');
            }, 2000);
        }

        function onError() {
            // Fallback: prompt user to copy manually
            window.prompt('Copy this link:', url);
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(url).then(onSuccess).catch(onError);
        } else {
            // Fallback for insecure contexts / older browsers
            try {
                const textarea = document.createElement('textarea');
                textarea.value = url;
                textarea.style.position = 'fixed';
                textarea.style.opacity = '0';
                document.body.appendChild(textarea);
                textarea.select();
                document.execCommand('copy');
                document.body.removeChild(textarea);
                onSuccess();
            } catch (e) {
                onError();
            }
        }
    });
}
